<template>
<section class="is-light hero section">
  <div class="card">
    <header class="card-header has-background-white-ter label is-size-6">
      <div class="column">
        <div class="level">
          <div class="level-left">
            <p class="card-header-title">
              <strong>
                <h2>Email Block/Unblock</h2>
              </strong>
            </p>
          </div>
          <div class="level-right">
            <div class="level-item">
              <button @click="toggleAddEditBlockMail('Add')" class="is-primary is-outlined is-small button" style="margin-right:0.5rem" title="Add Block Email">
                <b-icon icon="plus" size="small">
                </b-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- Pagination -->
    <div class="card-content" style="padding: 0 0.5rem;">
      <br>
      <div class="is-size-7">
        <div class="table_caption">
          <nav class="level">
            <div class="level-left">
              <div class="level-item">
                <p class="subtitle is-6">
                  Total Count: <strong>{{totalCount}}</strong>
                </p>
              </div>
              <!-- <div class="level-item">
            <button type="button" class="button is-small is-primary " @click="toggleConfirmModal()" title="Unblock Email" :disabled="!selectedRows.length">Unblock Email</button>
          </div> -->
            </div>
            <div class="level-right">
              <!-- <div class="level-item">
            <input type="search" name="search" autofocus value="search" placeholder="Enter email address" v-model.trim="search" class="input">
          </div> -->
              <div class="level-item">
                <button type="button" class="button is-small is-primary is-outlined" @click="toggleConfirmModal()" title="Unblock Email" :disabled="!selectedRows.length">Unblock Email</button>
              </div>
              <div class="level-item" v-if="emailList.length">
                <p class="is-smalltext padding">Showing <strong>{{page+1}}</strong> of <strong>{{totalPages}}</strong></p>
              </div>
              <div class="" v-if="emailList.length">
                <span class="padding">
                  <button type="button" :disabled="page === 0" v-on:click="loadPrev()" class="is-outlined button is-primary is-small">
                    <b-icon icon="chevron-left" size=""> </b-icon>
                  </button>
                </span>
                <span class="padding">
                  <button class="is-outlined button is-primary is-small" type="button" :disabled="page >= totalPages-1" v-on:click="loadMore()">
                    <b-icon icon="chevron-right" size=""> </b-icon>
                  </button>
                </span>
                <div class="select is-small">
                  <select v-model="pageSize" name="pagesize" v-on:change="changePageSize">
                    <option v-for="(p,index) in pageItemList" :key="index">{{p}}</option>
                  </select>
                </div>
                <a class="button is-primary is-small is-outlined" @click="toggleSearchModal" title="Search email">
                  <b-icon icon="magnify" size=""> </b-icon>
                </a>
              </div>
            </div>
          </nav>
        </div>
        <b-table :data="emailList" :hoverable="true" :is-row-checkable="(row) => row.status !== 'unblock'" class="custom_table" :loading="isLoading" :backend-sorting="true" v-if="emailList.length" :checked-rows.sync="selectedRows" checkable>
          <template slot-scope="props">
            <b-table-column field="user.emailaddress" label="Email Address" sortable>
              {{ props.row.customeremailid }}
            </b-table-column>
            <b-table-column field="user.status" label="Status">
              <span class="is-capitalized">
                {{ props.row.status }}
              </span>
            </b-table-column>

            <b-table-column field="user.reasonid" label="Block Reason">
              <template>
                {{ setBlockReason(props.row.blockreasonmasterid) }}
              </template>
            </b-table-column>
            <b-table-column field="user.createdby" label="Created By">
              {{ props.row.createdby }}
            </b-table-column>
            <b-table-column field="user.createddate" label="Created Date">
              <span class="">
                {{props.row.createddate||'' |dateFilter }}
              </span>
            </b-table-column>
            <b-table-column field="user.lastmodifiedby" label="Modified By">
              <span class="">
                {{ props.row.lastmodifiedby||'' }}
              </span>
            </b-table-column>
            <b-table-column field="user.lastmodifiedby" label="Modified Date">
              <span class="">
                {{ props.row.lastmodifieddate||''|dateFilter }}
              </span>
            </b-table-column>
            <b-table-column label="Action">
              <a @click="getByid(props.row.blockemailid)">
                <b-icon icon="square-edit-outline"></b-icon>
              </a>
            </b-table-column>
          </template>
        </b-table>
        <div class="is-size-7 has-text-centered no_record" v-if="!emailList.length">
          <p class="content has-text-grey">
            <b-icon icon="alert-decagram"></b-icon>
            &nbsp;<span class="is-size-6">No Records Found</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <!--  Add Blcok modal Start-->
  <div class="modal" :class="{'is-active':isAddEditBlockEmailModal}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <form class="" @submit.prevent=" addBlockeEmail ? createBlockEmail() : updateBlockEmail()">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <span v-if="addBlockeEmail">Add</span>
            <span v-if="editBlockedEmail">Edit</span> Block Email
          </p>
          <button class="delete has-background-danger" aria-label="close" @click="toggleAddEditBlockMail()" type="button"></button>
        </header>
        <section class="modal-card-body">

          <div class="columns is-multiline is-mobile ">
            <div class="column">
              <div class="field">
                <div class="label is-small">
                  Email ID:
                </div>
                <div class="control">
                  <input class="input is-small is-hovered" type="email" v-model.trim="createBlock.emailaddress" placeholder="Enter Email Id" :disabled='editBlockedEmail' required>
                </div>
              </div>
            </div>

            <div class="column" v-if="editBlockedEmail">
              <div class="field">
                <div class="label is-small">
                  Block Status:
                </div>
                <div class="control">
                  <div class="select is-small is-fullwidth ">
                    <select v-model="createBlock.status" @change="disable(createBlock.status)" class="is-hovered" required>
                      <option value="block">Block</option>
                      <option value="unblock">Unblock</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="field">
                <div class="label is-small">
                  Block Reason:
                </div>
                <div class="control">
                  <div class="select is-small is-fullwidth">
                    <select v-model="createBlock.reasonid" :disabled="statusDisabled" class="is-hovered" :required="createBlock.status==='block'">
                      <option :value="reason.blockreasonid" v-for="(reason,index) in reasonsData" :key="index">{{reason.blockreason}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column m-t-20">
              <div class="is-pulled-right">
                <button class="button is-small is-primary" type="submit">
                  Save
                </button>&nbsp;
                <button class="button is-small is-danger " type="button" @click="resetFormData()">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </section>
      </form>
    </div>
  </div>
  <!-- Add Block Modal End -->
  <div class="modal" :class="{'is-active':isSearchModal}">
    <div class="modal-background"></div>
    <form class="modal-card" @submit.prevent="searchTickets()">
      <header class="modal-card-head">
        <p class="modal-card-title">Search Block Email</p>
        <button class="delete" type="button" v-on:click="toggleSearchModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <div class="field">
              <div class="label is-small">
                Email ID:
              </div>
              <div class="control">
                <input class="input is-small is-hovered" type="email" v-model.trim="filterData.emailaddress" placeholder="Enter Email id">
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <div class="label is-small">
                Status:
              </div>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="filterData.status" class="is-hovered">
                    <option value="">--Select Status--</option>
                    <option v-for="(status,index) in statusArray" :value="status" :key="index">{{status}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <div class="label is-small">
                Reason:
              </div>
              <div class="control">
                <div class="select is-small is-fullwidth">
                  <select v-model="filterData.reasonid" class="is-hovered">
                    <option value="">--Select Reason--</option>
                    <option v-bind:value="reason.blockreasonid" v-for="reason in reasonsData" :key="reason.blockreasonid">{{reason.blockreason}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field is-pulled-right is-grouped">
              <p class="control">
                <button class="button is-small is-primary" type="submit">
                  Search
                </button>
              </p>
              <p class="control">
                <button type="button" class="button is-small" @click="reset">Reset</button>
              </p>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
      </footer>
    </form>
  </div>
</section>
</template>

<script>
//import CONSTANTS from '@/utils/constants'
//import filters from '@/filters/filter'
//import stores from '@/stores'
import commonFunction from '../../../commonFunction'
export default {
  name: 'blockunblockemail',
  data: function () {
    return {
      reasonsData: [],
      statusArray: ['block', 'unblock'],
      selectedRows: [],
      customerEmails: [],
      page: 0,
      noOfPages: 1,
      resultCount: 0,
      totalPages: 0,
      pageSize: 10,
      pageItemList: [10, 20, 30],
      isSearchModal: false,
      filterData: {
        status: '',
        emailaddress: '',
        reasonid: ''
      },
      worktypeid: 0,
      sourceid: 0,
      isSearchTickets: false,
      confirmMessage: '',
      isAddEditBlockEmailModal: false,
      addBlockeEmail: false,
      editBlockedEmail: false,
      statusDisabled: false,
      loggedUser: '',
      isLoading: false,
      selectedEmails: [],
      createBlock: {
        reasonid: '',
        emailaddress: '',
        status: ''
      },
      totalCount: 0,
      search: '',
      emailList: []
    }
  },
  created () {
    /*this.subdepartmentid = Number(this.$route.query.subdepartmentid)
    this.getBlockEmail()
    this.getBlockReason()
    let perm = stores.user.hasPermission('/emailr/blockunblockemail', 'Read')
    if (!perm) {
      this.$router.push({
        path: '/'
      })
      return this.$buefy.toast.open({
        message: 'You do not have access to this page.',
        type: 'is-danger'
      })
    } else {
      this.subdepartmentid = Number(this.$route.query.subdepartmentid)
      this.getBlockEmail()
      this.getBlockReason()
    }*/
     [this.subDepartmentList, this.DepartmentID,this.userdetail,this.permissiondata,this.userTypeForTicket, this.SummarySelectOptionObj, this.SummaryOptionObj]=commonFunction.getuserDetailsAndpermissionData();
    this.subDepartmentList.filter((m) => {
      if ((m.value) && (m.text.toLowerCase() === 'ccemail' || m.text.toLowerCase() === 'babyhugemail')) {
      return m
      }
    })
  },
  filters: {
  //  dateFilter: filters.dateFilter
  },
  methods: {
    resetBlockEmail: function () {
      this.createBlock.emailaddress = ''
      this.createBlock.reasonid = ''
      this.createBlock.status = ''
      this.blockemailid = ''
    },
    setBlockReason: function (reasonid) {
      for (var i = 0; i < this.reasonsData.length; i++) {
        if (Number(this.reasonsData[i].blockreasonid) === Number(reasonid)) {
          return this.reasonsData[i].blockreason
        }
      }
    },
    getByid: function (blockemailid) {
      this.isAddEditBlockEmailModal = true
      this.editBlockedEmail = true
      this.addBlockeEmail = false
      this.blockemailid = blockemailid
      return http.get(`${CONSTANTS.API_URL}/api/getblockemaildata`, {
        blockemailid: blockemailid
      })
        .then((result) => {
          if (result) {
            this.createBlock.emailaddress = result.customeremailid || ''
            this.createBlock.status = result.status || ''
            this.createBlock.reasonid = result.blockreasonmasterid || ''
          }
        })
        .catch((httpException) => {
          return this.$buefy.toast.open({
            message: httpException.message,
            type: 'is-danger'
          })
        })
    },
    updateBlockEmail: function () {
      let editBlock = {}
      editBlock.status = this.createBlock.status
      editBlock.customeremailid = this.createBlock.emailaddress
      editBlock.blockreasonmasterid = this.createBlock.reasonid
      editBlock.blockemailid = this.blockemailid
      Object.keys(editBlock).forEach((key) => {
        if (editBlock[key] === '' || editBlock[key] === null || editBlock[key] === undefined) {
          delete editBlock[key]
        }
      })
      return http.put(`${CONSTANTS.API_URL}/api/updateblockemail`, editBlock)
        .then((result) => {
          this.resetBlockEmail()
          this.isAddEditBlockEmailModal = false
          this.getBlockEmail()
          this.$buefy.toast.open({
            message: `Saved successfully.`,
            type: 'is-success'
          })
        })
        .catch((httpException) => {
          return this.$buefy.toast.open({
            message: httpException.message,
            type: 'is-danger'
          })
        })
    },
    createBlockEmail: function () {
      let addBlockObj = {
        blockreasonmasterid: this.createBlock.reasonid.toString(),
        customeremailid: this.createBlock.emailaddress,
        subdepartmentid: this.subdepartmentid
      }
      Object.keys(addBlockObj).forEach((key) => {
        if (addBlockObj[key] === '' || addBlockObj[key] === null || addBlockObj[key] === undefined) {
          delete addBlockObj[key]
        }
      })
      this.isLoading = true
      return http.post(`${CONSTANTS.API_URL}/api/createblockemail`, addBlockObj)
        .then((result) => {
          this.isLoading = false
          if (result && result.message && result.message.toLowerCase() === 'emailid already exist') {
            return this.$buefy.toast.open({
              message: `Email address already blocked.`,
              type: 'is-danger'
            })
          } else {
            this.resetBlockEmail()
            this.getBlockEmail()

            this.isAddEditBlockEmailModal = false
            return this.$buefy.toast.open({
              message: `Email Blocked successfully.`,
              type: 'is-success'
            })
          }
        })
        .catch((httpException) => {
          this.isLoading = false
          return this.$buefy.toast.open({
            message: httpException.message,
            type: 'is-danger'
          })
        })
    },
    getBlockEmail: function () {
      if (this.isSearchModal) {
        this.page = 0
      }
      let getObj = {
        page: Number(this.pageSize * this.page),
        pageSize: this.pageSize,
        status: this.filterData.status,
        customeremailid: this.filterData.emailaddress,
        blockreasonmasterid: this.filterData.reasonid,
        subdepartmentid: this.subdepartmentid
      }
      this.selectedRows = []
      Object.keys(getObj).forEach((key) => {
        if (getObj[key] === '' || getObj[key] === null || getObj[key] === undefined) {
          delete getObj[key]
        }
      })
      return http.get(`${CONSTANTS.API_URL}/api/getblockemail`, getObj)
        .then((result) => {
          if (result) {
            this.isSearchModal = false
            this.getTotalPages(result.count)
            this.emailList = result.rows
            this.totalCount = result.count
          }
        })
        .catch((httpException) => {
          return this.$buefy.toast.open({
            message: httpException.message,
            type: 'is-danger'
          })
        })
    },
    UnBlockEmail: function () {
      let BulkData = {
        blockemailid: this.selectedEmails,
        createdby: this.loggedUser.emailaddress,
        status: 'unblock'
      }
      Object.keys(BulkData).forEach((key) => {
        if (BulkData[key] === '' || BulkData[key] === null) {
          delete BulkData[key]
        }
      })
      this.isLoading = true
      return http.put(`${CONSTANTS.API_URL}/api/updatebulkblockemail`, BulkData)
        .then((result) => {
          this.isLoading = false
          if (result) {
            this.$buefy.toast.open({
              message: `Email unblocked successfully.`,
              type: 'is-success'
            })
          }
          this.getBlockEmail()
        })
        .catch((httpException) => {
          this.isLoading = false
          return this.$buefy.toast.open({
            message: httpException.message,
            type: 'is-danger'
          })
        })
    },
    toggleAddEditBlockMail: function (option) {
      this.editBlockedEmail = false
      this.addBlockeEmail = true
      if (option === 'Add') {
        this.statusDisabled = false
        this.addBlockeEmail = true
        this.editBlockedEmail = false
      } else {
        this.addBlockeEmail = false
        this.editBlockedEmail = true
      }
      this.isAddEditBlockEmailModal = !this.isAddEditBlockEmailModal
      this.resetBlockEmail()
    },
    getBlockReason: function () {
      return http.get(`${CONSTANTS.API_URL}/api/getblockreasondata`)
        .then((result) => {
          if (result) {
            this.reasonsData = []
            result.forEach((r) => {
              this.reasonsData.push({
                blockreasonid: r.blockreasonid ? r.blockreasonid : '',
                blockreason: r.blockreason ? r.blockreason : ''
              })
            })
          }
        })
        .catch((httpException) => {
          return this.$buefy.toast.open({
            message: httpException.message,
            type: 'is-danger'
          })
        })
    },
    searchTickets: function () {
      this.isSearchTickets = true
      if (this.isSearchTickets && !this.filterData.status && !this.filterData.reasonid && !this.filterData.emailaddress) {
        return this.$buefy.toast.open({
          message: 'Please select at least one filter option.',
          type: 'is-danger'
        })
      } else {
        this.getBlockEmail()
      }
    },
    disable: function () {
      if (this.createBlock.status === 'block') {
        this.statusDisabled = false
      } else {
        this.createBlock.reasonid = 0
        this.statusDisabled = true
      }
    },
    toggleConfirmModal: function () {
      let email = ''
      if (this.selectedRows && this.selectedRows.length > 1) {
        email = 'emails'
      } else {
        email = 'email'
      }
      this.selectedEmails = []
      this.selectedRows.forEach((user) => {
        this.selectedEmails.push(user.blockemailid)
      })
      this.confirmMessage = `<i class="fa fa-exclamation-circle fa-lg has-text-danger"></i> Are you sure you want to unblock ${email}?`
      this.$buefy.dialog.confirm({
        message: this.confirmMessage,
        onConfirm: () => this.UnBlockEmail()
      })
    },
    fetchReasonId: function (id) {
      for (var i = 0; i < this.reasonsData.length; i++) {
        if (this.reasonsData[i].blockreasonid === id) {
          return this.reasonsData[i].blockreason
        }
      }
    },
    getTotalPages: function (result) {
      let total = parseInt(result / this.pageSize)
      let remainder = result % this.pageSize
      if (remainder > 0) {
        this.totalPages = total + 1
      } else {
        this.totalPages = total
      }
    },
    toggleSearchModal: function () {
      this.isSearchModal = !this.isSearchModal
      this.filterData = {}
    },
    reset: function () {
      this.filterData.status = ''
      this.filterData.emailaddress = ''
      this.filterData.reasonid = ''
      this.customerEmails = []
    },
    loadMore: function () {
      this.page++
      this.getBlockEmail()
    },
    loadPrev: function () {
      this.page--
      this.getBlockEmail()
    },
    changePageSize: function () {
      this.page = 0
      this.getBlockEmail()
    },
    resetFormData: function () {
      if (this.editBlockedEmail) {
        this.createBlock.status = ''
        this.createBlock.reasonid = ''
      } else {
        this.createBlock.emailaddress = ''
        this.createBlock.status = ''
        this.createBlock.reasonid = ''
      }
    }
  }
}
</script>

<style lang="css" scoped="">
  .previewModal {
      width: 80% !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/emailr/blockunblockemail.vue?1149113e